import { Player, useGameContext } from "GameContext";

import {
  useState,
  useEffect,
} from "react";

import { getRoleConstants } from "utils/game-information-constants";

export default function NGO() {
  const {
    playerInfo,
    roleGroups,
  } = useGameContext();

  const roleGroup = roleGroups[`${playerInfo?.estate}-${playerInfo?.role}`]

  const subsidies = roleGroup?.subsidy ?? 0

  return (
    <div>
      <p>Conservationist</p>
      <br/>
      <p>Scientific monitoring cost: {getRoleConstants("Conservationist", "public")?.staticCosts[0][0]}</p>
      <br/>
      <p>Subsidies Gained: {subsidies}</p>
      <br/>
    </div>
  )

}
